<div class="overflow-y-auto max-h-[75vh] hide-scrollbar md:show-scrollbar">
  <div
    class="relative w-[434px] max-w-full h-full px-8 py-14 rounded flex flex-col items-center gap-4"
    [style.backgroundColor]="bgBase()"
  >
    <neopos-icon name="email-circle" class="text-[58px] mb-4 mx-auto" />

    <p class="text-center font-medium text-lg leading-none">
      {{ 'Link aktywacyjny został wysłany' | translate }}
    </p>

    <p class="text-sm leading-none text-center">
      {{
        'Sprawdź swoją skrzynkę e-mail i kliknij w link, aby aktywować konto. Jeśli nie widzisz wiadomości, sprawdź folder „Spam” lub „Oferty”.'
          | translate
      }}
    </p>

    <acc-button
      type="button"
      [inputId]="'acc-button-register-summary-close'"
      theme="SECONDARY"
      widthType="fit"
      (onClick)="close()"
      (document:keydown.escape)="close()"
      [attr.ariaLabel]="'Rozumiem' | translate"
      class="mt-4"
    >
      {{ 'Rozumiem' | translate }}
    </acc-button>
  </div>
</div>
